import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
import { v4 as uuidv4 } from "uuid";
import { debounce } from "lodash";
export default defineComponent({
  props: {
    prompt: {
      type: String,
      default: ""
    },
    promptHTML: {
      type: String,
      default: ""
    },
    colSize: {
      type: String,
      default: "6"
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cols: {
      type: String,
      default: "10"
    },
    rows: {
      type: String,
      default: "10"
    },
    maxlength: {
      type: String,
      default: "800"
    },
    maxrows: {
      type: String,
      default: ""
    },
    resize: {
      type: String,
      default: "none"
    }
  },
  data() {
    return {
      labelValue: uuidv4(),
      val: this.value,
      offset: 0,
      maxLen: _parseInt(this.maxlength),
      rowsNumber: _parseInt(this.rows)
    };
  },
  computed: {
    innerValue() {
      return this.value;
    }
  },
  watch: {
    val(value, oldValue) {
      const currentRows = this.validateMaxRows(value);
      this.val = currentRows >= _parseInt(this.rows) ? oldValue : value;
    }
  },
  methods: {
    validateMaxRows(inputString) {
      return (inputString.match(/\n/g) || []).length;
    },
    handleChange: debounce(function () {
      this.$emit("input", this.val);
    }, 500)
  }
});